function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTollEuro = function SvgTollEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M724.175 970.88q-72.065 0-133.163-42.299t-83.03-114.363h-84.598v-37.599h77.078q-2.507-17.546-2.193-31.332.313-13.786 2.193-31.332h-77.078v-37.6h84.598q21.932-72.063 83.03-114.362t133.163-42.299q43.238 0 81.15 14.726t69.245 42.926l-26.946 26.319q-25.692-22.56-57.651-34.466t-65.798-11.906q-58.905 0-107.47 32.899t-68.618 86.164h176.088v37.599H538.687q-3.133 16.92-3.133 31.332 0 14.413 3.133 31.332h185.488v37.599H548.087q20.053 53.265 68.618 86.164t107.47 32.899q33.212 0 65.171-11.28t58.905-35.092l26.319 26.32q-27.573 26.318-67.051 41.984-39.48 15.667-83.344 15.667",
    style: {
      strokeWidth: 0.626646
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.326 176.788 48.327 355.214M192.135 177.419l-86.064 796.71",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 48,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.384 194.835.131 163.04M336.384 458.057l.131 163.04",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 44,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.383 733.697.121 149.452",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 43.9994,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgTollEuro;